import { render } from "./BeforeLoginLayout.vue?vue&type=template&id=bc56886e&scoped=true&ts=true"
import script from "./BeforeLoginLayout.vue?vue&type=script&lang=ts"
export * from "./BeforeLoginLayout.vue?vue&type=script&lang=ts"

import "./BeforeLoginLayout.vue?vue&type=style&index=0&id=bc56886e&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc56886e"]])

export default __exports__